export default {"src":"/_next/static/image/public/images/flags/flag_60.2204e8954a75642314298da34009e884.svg","height":16,"width":24};